import * as React from 'react';
import { Summary } from '../../Models/Report';
import { PieChart as PieChartRe, Pie, Cell, Sector, Label } from 'recharts';
import './PieChart.scss';
import { formatAmount } from '../../Utils/NumberFormat';
import Empty from 'antd/lib/empty';

export interface IPieChartSummary {
	data: Summary[];
	loading: boolean;
}

export const PieChart = (props: IPieChartSummary) => {


	let data = props.data.filter(d => d.total > 0);
	data = data.sort((a: Summary, b: Summary) => {
		if (a.total > b.total) {
			return -1;
		}
		if (b.total > a.total) {
			return 1;
		}
		return 0;
	}).reverse();
	const renderActiveShape = (props: any) => {
		const RADIAN = Math.PI / 180;
		const {
			cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
			fill, name, percent
		} = props;
		const sin = Math.sin(-RADIAN * midAngle);
		const cos = Math.cos(-RADIAN * midAngle);
		let sx = cx + (outerRadius + 10) * cos;
		const sy = cy + (outerRadius + 10) * sin;
		const mx = cx + (outerRadius + 30) * cos;
		const my = cy + (outerRadius + 30) * sin;
		let ex = mx + (cos >= 0 ? 1 : -1) * 22;
		const ey = my;

		let x = ex + (cos >= 0 ? 1 : -1) * 12;
		let eex = 0;
		let textAnchor = cos >= 0 ? 'start' : 'end';

		if (midAngle < -260) {
			eex = 40;
			x += 60;
			textAnchor = 'start';
		}
		return (
			<g>

				<Sector
					cx={cx}
					cy={cy}
					innerRadius={innerRadius}
					outerRadius={outerRadius}
					startAngle={startAngle}
					endAngle={endAngle}
					fill={fill}
				/>
				<path d={`M${sx},${sy}L${mx},${my}L${ex + eex},${ey}`} stroke={fill} fill="none" />
				<circle cx={ex + eex} cy={ey} r={2} fill={fill} stroke="none" />
				<text x={x} y={ey} dy={0} textAnchor={textAnchor} fill="#999">
					{name.length > 20 ? name.substr(0, 20) + '...' :  name}
				</text>
				<text x={x} y={ey} dy={10} textAnchor={textAnchor} fill="#999">
					{(percent * 100).toFixed(2)}%
				</text>
			</g>
		);
	};
	const total = props.data.map(c => c.total).reduce((a, c) => a + c, 0);
	if (total <= 0) {
		return <Empty description="No tenemos datos para mostrar" />
	}
	if (props.loading) {
		return <div />
	}
	return (<div className="PieChart" >
		<PieChartRe className="PieChart-Chart"  width={600} height={300}>
		<Pie isAnimationActive={false} outerRadius={90} startAngle={-268} paddingAngle={data.length === 1 ? 0 : 15} data={data} dataKey="total" nameKey="name" innerRadius={50} label={renderActiveShape}>
			{
				data.map((entry, index) => (
					<Cell key={`cell-${index}`} fill={entry.color} />
				))
			}
			<Label offset={0} position="center" content={(p) => {
				return <text x={p.viewBox.cx - 13} y={p.viewBox.cy - 5} style={{ fontWeight: 600 }} fontSize="1.1rem">{formatAmount(total)}</text>
			}
			} />
			<Label position="center" style={{ marginTop: '5px' }} content={(p) => {
				return <text  x={p.viewBox.cx - 10} y={p.viewBox.cy + 10}  fontSize="1.1rem">Kton</text>
			}} >

			</Label>
		</Pie>

	</PieChartRe>
	</div>);
};

export default PieChart;
